<!-- 主页已登录 -->
<template>
  <div class="home-component-container">
    <div class="reward">
      <img class="bg-img" :src="homeImg" alt="">
      <div class="btn" @click="copyLink">马上邀请好友</div>
    </div>
    <div class="method">
      <img class="bg-img" :src="home2Img" alt="">
      <div class="btn-list">
        <div class="btn" @click="open">我的邀请码</div>
        <div class="btn" @click="addCard">结算信息</div>
      </div>
    </div>
    <!-- 邀请码 -->
    <vanOverlay :show="showOverlay"    :lock-scroll="false">
      <div class="invite-wrapper"   @click.stop>
        <div class="close-img" @click="close">
          <van-icon name="close" color="#ffffff" size="32px" />
        </div>
        <div class="invite-title">邀请好友加入PhotonPay光子易</div>
        <div class="invite-reward">可获得最高<span class="red">500元</span>奖励</div>
        <div
          class="qr-img"
        >
          <img
            class="img"
            :src="pictureUrl"
          />
        </div>
        <div class="btn-list">
          <div class="btn-img" @click="savePicture">保存图片</div>
          <div class="btn-share" @click="shareToFriend">马上邀请好友</div>
        </div>
        <!-- <div style="height: 128px;"></div> -->
      </div>
    </vanOverlay>
  </div>
</template>

<script>
import homeImg from '@/assets/images/home/homeDone1.jpg'
import home2Img from '@/assets/images/home/homeDone2.png'
import closeIcon from '@/assets/images/home/closeIcon.png'
import { apiGet } from '@/services'
import { shareMessageToFriend} from '@/utils/index.js'
import bg2 from '@/assets/images/bg2.png'
import canvasUtils from '@/utils/canvas'
const setOptions = ({avatar, nickName, qrCode}) => ({
  width: 871,
  height: 943,
  quality: 1,
  config: [
    {
      type: 'img',
      src: bg2,
      x: 0,
      y: -1,
      width: 871,
      height: 945,
      borderRadius: 20
    },
    {
      type: 'img',
      src: avatar,
      x: 338,
      y: 2.5,
      width: 80 * 2,
      height: 80 * 2,
      borderRadius: 40 * 2
    },
    {
      type: 'text',
      text: nickName,
      x: 416,
      y: 210,
      fontSize: 36,
      fontWeight: 'bold',
      color: '#302b3e',
      textAlign: 'center'
    },
    {
      type: 'img',
      src: qrCode,
      x: 268,
      y: 400,
      width: 150 * 2,
      height: 150 * 2,
      borderRadius: 8
    }
  ]
})
export default {
  name: 'no-auth-home',
  props: {
    propsData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      showOverlay: false,
      homeImg,
      home2Img,
      closeIcon,
      linkUrl: '',
      pictureUrl: ''
    }
  },
  components: { },
  mounted() {
    this.getQrCode()
    this.getLink()
    // 如果有需要动态调整宽度，可以加上相关逻辑
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto'
  },
  methods: {
    close() {
      document.body.style.overflow = 'auto'
      this.showOverlay = false
    },
    open() {
      document.body.style.overflow = 'hidden'
      this.showOverlay = true
    },
    getLink() {
      apiGet('partner/open/generateInviteLink').then(res => {
        this.linkUrl = res.data
      })
    },
    async copyLink() {
      this.$copyText(this.linkUrl).then(
        (e) => {
          // this.$notify.success(this.$t('app.sentence.copyLinkSuccess'))
          this.shareToFriend()
        },
        (e) => {
          this.$notify.error(this.$t('app.sentence.copyLinkFail'))
        }
      )
    },
    getQrCode() {
      apiGet('partner/open/findPartnerInfo').then(res => {
       canvasUtils.drawFromConfig(setOptions({
        avatar: res.data.headImgUrl,
        qrCode: 'data:image/png;base64,' + res.data.inviteLinkQrCode,
        nickName: res.data.partnerName
       })).then((data) => {
        this.pictureUrl = data
      })
      })
    },
    // 保存图片至相册
    savePicture() {
      this.$router.push('/savePic')
    },
    // 分享链接至朋友
    async shareToFriend() {
      shareMessageToFriend({
        title: 'PhotonPay光子易',
        desc: '邀请好友加入PhotonPay光子易',
        link: this.linkUrl,
        imgUrl: 'https://x-api1.uat.photontech.cc/file/download/ee47Pd3a4pNb0g.png',
        success: () => {
          this.$notify.success('请点击右上角“···”按钮进行分享！')
        },
        fail: function(error) {
          alert(JSON.stringify(error))
        }
      })
    },
    addCard() {
      this.$router.push({
        path: '/addCard'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.btn{
  height: 40px;
  width: calc(100vw - 110px);
  margin: 0 auto;
  background: #ffb600;
  border-radius: 40px;
  font-size: 16px;
  color: #302b3e;
  line-height: 20px;
  text-align: center;
  font-weight: 600;
  line-height: 40px;
}
.reward{
  position: relative;
  img{
    margin-top: -88px;
  }
  .btn{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 40px;
  }
}
.method{
   position: relative;
   .btn-list{
      width: 100%;
      box-sizing: border-box;
      padding: 0 25px;
      position: absolute;
      bottom: 40px;
      display: flex;
      justify-content: space-between;
      .btn{
        width: calc(50% - 5px);
        margin: 0;
      }
   }
}
.bg-img{
  width: 100%;
  height: auto;
}

.invite-wrapper{
  padding-top: 65px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  .close-img{
    position: absolute;
    z-index: 10001;
    width: 22px;
    right: 14px;
    top: 10px;
    img{
      width: 100%;
    }
  }
  .invite-title{
    text-align: center;
    font-size: 18px;
    color: #FFFFFF;
    font-weight: 800;
  }
  .invite-reward{
    text-align: center;
    color: #fff;
    font-size: 16px;
    margin-top: 5px;
    .red{
      color: #FF4242;
    }
  }

  .qr-img{
    width: 100vw;
    margin-top: 30px;
    overflow-x: hidden;
    img{
      display: block;
      width: calc(100% + 40px);
      height: auto;
      margin-left: -12px;
    }
  }
  .btn-list{
    padding: 33px 16px;
    display: flex;
    .btn-img{
      height: 40px;
      width: 130px;
      background: #4C4C4C;
      color: #FFFFFF;
      text-align: center;
      font-weight: 600;
      line-height: 40px;
      border-radius: 40px;
      margin-right: 13px;
    }
    .btn-share{
      flex: 1;
      height: 40px;
      font-weight: 600;
      background: #FFB600;
      color: #302B3E;
      text-align: center;
      line-height: 40px;
      border-radius: 40px;
    }
  }
}
</style>
